/**
 * Shared shapes for the enquiry form.
 *
 * These live outside `actions.ts` on purpose: a `"use server"` module may only
 * export async functions. Constants exported from one arrive as `undefined` on
 * the client, which is a silent failure until something reads a property off
 * them.
 */

export const INTENTS = {
  consultation: "Book a consultation",
  proposal: "Request a proposal",
  expert: "Speak to an expert",
  training: "Academy / training enquiry",
  other: "Something else",
} as const;

export type Intent = keyof typeof INTENTS;

export type EnquiryState = {
  status: "idle" | "success" | "error";
  message?: string;
  errors: Partial<Record<"name" | "email" | "organisation" | "message", string>>;
  values: {
    name: string;
    organisation: string;
    email: string;
    phone: string;
    intent: string;
    message: string;
  };
};

export const emptyEnquiry: EnquiryState = {
  status: "idle",
  errors: {},
  values: {
    name: "",
    organisation: "",
    email: "",
    phone: "",
    intent: "consultation",
    message: "",
  },
};

export function isIntent(value: unknown): value is Intent {
  return typeof value === "string" && value in INTENTS;
}
